module.exports = __webpack_public_path__ + "img/modal-logo.2edbb533.svg";